<template>
    <div style="">
        <div>
            <img style="width: 100%" :src="course_info.picture_url">
            <div style="padding: 10px 10px;line-height: 22px;background-color: white">
                <div style="font-size: 18px">
                    {{course_info.name}}
                </div>
                <div v-if="course_info.fee_type === 'paid'" style="" class="course_info_box">
                <span class="bootcamp_price" v-if="course_info.price>0">
                    <span style="font-size: 14px">{{course_info.price_name}}</span>￥{{ course_info.price }}
                </span>
                    <span class="bootcamp_price" style="text-decoration: line-through;color: lightsteelblue"
                          v-if="course_info.real_price>0">
                    ￥{{ course_info.real_price }}
                </span>
                </div>
                <div class="course_numbers_div">
                    <span v-if="course_info.online_type=='online_public'" style="color: #59cf4a;margin-right: 5px">线上课程</span>
                    <span v-if="course_info.online_type=='online_quality'" style="color: #ffc500;margin-right: 5px">线上精品</span>
                    <span v-if="course_info.online_type=='online_live'" style="color: #28d7f6;margin-right: 5px">线上直播</span>
                    <span v-if="course_info.online_type=='symposium'" style="color: #ea5e00;margin-right: 5px">研讨课程</span>
                    <span v-if="course_info.online_type=='offline_public'" style="color: #23419a;margin-right: 5px">线下课程</span>
                    <span v-if="course_info.online_type=='offline_quality'" style="color: #9a2edc;margin-right: 5px">线下精品</span>
                    <span v-if="course_info.online_type=='offline_salon'" style="color: #ea0094;margin-right: 5px">线下沙龙</span>
                    <span class="course_numbers_p">{{ course_info.students_count}} 人学过</span>
                    <span class="course_numbers_p"> {{ course_info.followers_count}} 人收藏</span>
                    <span class="course_numbers_p">
                        主讲: {{ course_info.teacher.name }}
                    </span>
                </div>
            </div>

            <div style="padding: 5px 10px;margin-top: 10px; background-color: white">
                <div style="font-weight: bold">课程介绍</div>
                <div v-html="course_info.long_description"></div>
            </div>
            <div style="padding: 0 10px;margin-top: 10px; background-color: white">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="'课程内容('+course_content.labs.length+')'" name="content">
                        <div style="line-height: 28px;margin-top: 10px;">
                            <div v-for="(course_process, index) in course_content.labs"
                                 :key="index">{{course_process.name}}  <span>  <span class="lesson_enter">
                        <!--<router-link :to="{ name: 'test_socket', params: { id: course_process.id } }"-->
                                     <!--target="_blank">-->
                            <!--<button class="btn" style="background-color: #009933;margin-top: 8px;color:white">进入研讨会</button>-->
                        <!--</router-link>-->

                        <button v-if="course_process.type==='symposium'" :class="course_process.type==='symposium'?'btn':'not_show'" style="background-color: #009933;position: absolute;right: 10px;color:white" @click="to_symposium(course_process)">开始研讨</button>

                        <router-link  style ="position: absolute;right: 10px;" v-if="course_process.video_url" :to="{ name: 'playback', params: { id: course_process.parent.id },query: { id: course_process.id } }"
                                     target="_blank">
                            <el-button size="mini" style="background-color: #FF9933;color:white">视频回看</el-button>
                        </router-link>
                        <router-link  style="position: absolute;right: 10px;" v-if="course_process.media_url" :to="{ name: 'learning', params: { id: course_process.parent.id },query: { id: course_process.id } }"
                                     target="_blank">
                            <el-button size="mini" style="background-color: #009933;color:white">课程学习</el-button>
                        </router-link>
                    </span></span>
                            </div>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane :label="'课程评论('+comments.results.length+')'" name="comment">
                        <div class="comments-text" style="" v-for="item in comments.results"
                             :key="item">
                            <div style="width:40px;float:left;">
                                <img style="width: 40px; height: 40px;border-radius: 50%;"
                                     :src="item.author.avatar_url"/>
                            </div>
                            <div style="width:550px;margin-left:50px;border-bottom:1px solid #eee;">
                                <div>{{item.content}}</div>
                                <div style="color: #B0B0B0;">{{item.created_at}}</div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="'课程问答('+qa_information.results.length+')'" name="question">
                        <div class="comments-text" style="" v-for="(item, index) in qa_information.results"
                             :key="index">
                            <div style="width:40px;float:left;">
                                <img style="width: 40px; height: 40px;border-radius: 50%;"
                                     :src="item.author.avatar_url"/>
                            </div>
                            <div style="width:550px;margin-left:50px;border-bottom:1px solid #eee;">
                                <div style="font-weight: bold">{{item.title}}</div>
                                <div>{{item.content_description}}</div>
                                <div style="color: #B0B0B0;">{{item.created_at}}</div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="'课程心得('+report_info.results.length +')'" name="report">
                        <div class="comments-text" style="" v-for="(item, index) in report_info.results"
                             :key="index">
                            <div style="width:40px;float:left;">
                                <img style="width: 40px; height: 40px;border-radius: 50%;"
                                     :src="item.author.avatar_url"/>
                            </div>
                            <div style="width:550px;margin-left:50px;border-bottom:1px solid #eee;">
                                <div>{{item.content_description}}</div>
                                <div style="color: #B0B0B0;">{{item.created_at}}</div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="footer-box">
                <div v-if="sign_on==false" class="follow_course_div">
                     <span class="follow_span"
                           @click="show_login('on')"
                     > 收藏</span>
                </div>
                <div v-else class="follow_course_div">
                     <span class="follow_span"
                           v-if="!userstatus_info.is_followed"
                           @click="_change_follow(true)"
                     > 收藏</span>
                    <span class="followed_span"
                          v-if="userstatus_info.is_followed"
                          @click="_change_follow(false)"
                    >已收藏</span>
                </div>
                <div style="position: absolute;right: 10px;">
                    <div v-if="sign_on==false">
                    <div v-if="course_info.is_active">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="course_info.fee_type==='free'"
                                @click="show_login('on')"
                        >加入课程
                        </button>
                        <a href="/vip" target="_blank" class="btn course_side_base_btn join_member_button"
                           v-if="course_info.fee_type==='member'"
                        >加入会员免费学
                        </a>
                        <button class="btn course_side_base_btn buy_course_button"
                                v-if="course_info.fee_type==='bootcamp' || course_info.fee_type==='paid'"
                                @click="show_login('on')"
                        >立即购买
                        </button>

                    </div>
                    <div v-else>
                        <button class="btn course_side_base_btn apply_course_button"
                                @click="show_login('on')"
                        >立即报名
                        </button>
                    </div>
                    <button class="btn course_side_base_btn buy_course_button"
                        style="margin-top: 10px;margin-bottom: 10px"
                        v-if="course_info.fee_type==='paid' && userstatus_info.is_business && !userstatus_info.group_buy_id"
                        @click="start_group_buy(course_info.id)"
                    >发起拼团
                    </button>
                    <button class="btn course_side_base_btn buy_course_button"
                            style="margin-top: 10px;margin-bottom: 10px"
                            v-if="course_info.fee_type==='paid' && userstatus_info.is_business && userstatus_info.group_buy_id"
                            @click="start_group_buy(course_info.id)"
                    >我的拼团
                    </button>
                </div>
                <div v-else>
                    <el-dialog :modal-append-to-body='false'
                               :visible.sync="dialogVisible"
                               width="80%">
                        <ul class="nav_title_ul" style="margin-top: -40px">
                            <li class="nav_title_li"
                                :class="nav_title==='购买' ? 'active_nav' : ''"
                                @click="tab_nav('购买')"
                            >
                                购买
                            </li>
                            <li class="nav_title_li"
                                :class="nav_title==='充值' ? 'active_nav' : ''"
                                @click="tab_nav('充值')"
                            >
                                充值
                            </li>
                        </ul>
                        <div class="stuff_div">
                            <keep-alive>
                                <component :is="stuff_component_dict[nav_title]" :data="course_info"
                                           :user_item_id="user_course_id" :type="'ujoyer.course.course'"
                                           :all_need_count="course_info.price * 100"
                                           :recharge_amount="course_info.price"></component>
                            </keep-alive>
                        </div>
                        <!--<span slot="footer" class="dialog-footer">-->
                        <!--<span v-if="nav_title==='购买'" style="font-size: 27px;float: left">购买：{{course_info.name}}</span>-->
                        <!--<span v-if="nav_title==='充值'" style="font-size: 27px;float: left">付款：<span style="color: red">￥399</span></span>-->
                        <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
                        <!--<el-button type="primary" @click="confirm_buy(course_info,user_all_copper_count,expense_all_copper_count,need_count)"-->
                        <!--:disabled="user_all_copper_count<expense_all_copper_count">确 定</el-button>-->
                        <!--</span>-->
                    </el-dialog>
                    <div v-if="course_info.is_active">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="(course_info.fee_type==='free' ||
                                    (course_info.fee_type==='member' && (user_info.member_type == 'plus' || user_info.member_type == 'premium')) ||
                                    (course_info.fee_type==='bootcamp' && user_info.member_type == 'premium') )
                                   && userstatus_info.status!=='active'"
                                @click="join_course()"
                        >加入课程
                        </button>
                        <!--<el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button>-->


                        <button class="btn course_side_base_btn buy_course_button"
                                v-if="(course_info.fee_type==='paid' ||
                                    (course_info.fee_type==='member' && (user_info.member_type == 'plus' || user_info.member_type == 'premium')) ||
                                    (course_info.fee_type==='bootcamp' && user_info.member_type == 'premium') )
                                   && userstatus_info.status!=='active'"
                                @click="to_buy(course_info.id)"
                        >立即购买
                        </button>

                        <a href="/vip" target="_blank" class="btn course_side_base_btn join_member_button"
                           v-if="(course_info.fee_type==='member' && user_info.member_type == null)
                                   && userstatus_info.status!=='active'"
                        >加入会员免费学
                        </a>
                        <button class="btn course_side_base_btn buy_course_button"
                                v-if="(course_info.fee_type==='bootcamp' && user_info.member_type != 'premium')
                                   && userstatus_info.status!=='active'"
                        >立即购买
                            <!-- @click="join_course()" -->
                        </button>
                    </div>
                    <div v-else>
                        <button v-if="!is_applyed" class="btn course_side_base_btn apply_course_button" style=""
                                @click="_apply_course('apply')"
                        >立即报名
                        </button>
                    </div>
                    <button class="btn course_side_base_btn buy_course_button"
                        style="margin-top: 10px;margin-bottom: 10px"
                        v-if="course_info.fee_type==='paid' && userstatus_info.is_business && !userstatus_info.group_buy_id"
                        @click="start_group_buy(course_info.id)"
                    >发起拼团
                    </button>
                    <button class="btn course_side_base_btn buy_course_button"
                            style="margin-top: 10px;margin-bottom: 10px"
                            v-if="course_info.fee_type==='paid' && userstatus_info.is_business && userstatus_info.group_buy_id"
                            @click="start_group_buy(course_info.id)"
                    >我的拼团
                    </button>
                    <el-dialog title="填写信息" :modal-append-to-body='false' :visible.sync="dialogFormVisible" width="80%">
                        <el-form :model="form" ref="form" :rules="rules">
                            <el-form-item label="真实姓名" :label-width="formLabelWidth" prop="realname">
                                <el-input v-model="form.realname" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
                                <el-input v-model="form.phone" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="单位名称" :label-width="formLabelWidth" prop="company">
                                <el-input v-model="form.company" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="岗位名称" :label-width="formLabelWidth" prop="job">
                                <el-input v-model="form.job" autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="微信号" :label-width="formLabelWidth">
                                <el-input v-model="form.wechat_number" autocomplete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取消</el-button>
                            <el-button type="primary" @click="apply_course('apply')">下一步
                            </el-button>
                        </div>
                    </el-dialog>

                </div>
                <div v-if="course_info.is_active">
                    <!--<a :href="'/test_socket/'+userstatus_info.last_learned_lesson_id "-->
                    <!--target='_blank' v-if="sign_on==true && userstatus_info.last_learned_lesson_info.type == 'symposium'">-->
                    <!--<button class="btn course_side_base_btn join_in_course_button"-->
                    <!--v-if="userstatus_info.status==='active'">-->
                    <!--进入研讨-->
                    <!--</button>-->
                    <!--</a>-->
                    <a :href="'/courses/'+ userstatus_info.course_id +'/learning/?id='+userstatus_info.last_learned_lesson_id "
                       target='_blank' v-if="sign_on==true  && userstatus_info.last_learned_lesson_info.media_url">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="userstatus_info.status==='active'">
                            继续学习
                        </button>
                    </a>
                    <a :href="'/c/'+ userstatus_info.course_id +'/playback/?id='+userstatus_info.last_learned_lesson_id "
                       target='_blank' v-if="sign_on==true  && userstatus_info.last_learned_lesson_info.video_url">
                        <button class="btn course_side_base_btn join_in_course_button"
                                v-if="userstatus_info.status==='active'">
                            继续学习
                        </button>
                    </a>
                </div>
                <div v-else>
                    <!--<button v-if="is_applyed" class="btn course_side_base_btn applyed_course_button"-->
                    <!--@click="apply_course('cancel')" @mouseover="applyed_hover('enter')"-->
                    <!--@mouseout="applyed_hover('out')"-->
                    <!--&gt;{{applyed_then_exit}}-->
                    <!--</button>-->
                    <button v-if="is_applyed" class="btn course_side_base_btn applyed_course_button"
                    >{{applyed_then_exit}}
                    </button>
                </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import Expense from '@/components/pay_page/expense.vue'
    import Pay from '@/components/pay_page/pay.vue'
    import courseApi from '@/api/courses/course_information.js'
    import groupBuyApi from '@/api/group_buy/group_buy.js'
      import SymposiumApi from '@/api/symposium/symposium.js'

    export default {
        name: "course_mobile",
        components: {
            Expense,
            Pay
        },
        data() {
            return {
                activeName: 'content',
                fee_type_dict: {
                    'free': '免费',
                    'member': '加入会员免费'
                },
                nav_title: '购买',
                stuff_component_dict: {
                    '购买': 'Expense',
                    '充值': 'Pay'
                },
                dialogVisible: false,
                user_course_id: 0,
                is_applyed: false,
                applyed_then_exit: '已报名',
                dialogFormVisible: false,
                form: {
                    realname: '',
                    phone: '',
                    company: '',
                    job: '',
                    wechat_number: '',
                },
                rules: {
                    realname: [
                        {required: true, message: '请输入真实姓名', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号", trigger: "blur"}
                    ],
                    company: [
                        {required: true, message: '请输入单位名称', trigger: 'blur'},
                    ],
                    job: [
                        {required: true, message: '请输入岗位名称', trigger: 'blur'},
                    ],
                },
                formLabelWidth: '100px'
            }
        },
        methods: {
            ...mapActions({
                get_qa: 'course/change_qa_information',
                change_follow: 'course/change_follow',
                get_report: 'course/change_report_information',
                join: 'course/join_course',
                show_login: 'loginState/change_show_state'
            }),
            to_symposium(course_process) {
                if (this.sign_on) {
                    SymposiumApi.get_is_socket_opened(course_process.id).then(res => {
                        let data = res.data
                        if(this.course_content.is_end){
                            this.$message('课程结束，请联系工作人员');
                            return
                        }
                        if (data.is_socket_opened) {
                            window.open("https://hr.ujoyer.com/b#/cl/" + course_process.id)
                        } else {
                            if (data.teachers.includes(Number(cookies.get('userId')))) {
                                window.open("https://hr.ujoyer.com/b#/cl/" + course_process.id)
                            } else {
                                this.$message('研讨会未开启，待开启后请重试');
                            }
                        }
                    })
                } else {
                    this.change_show_state('on')
                }
            },
            tab_nav(nav_title) {
                this.nav_title = nav_title
            },
            to_buy(course_id) {
                courseApi.join_course({'id': course_id}).then((res) => {
                    if (res.data.code == 'success') {
                        this.user_course_id = res.data.user_course_id
                    }
                })
                this.dialogVisible = true
            },
            start_group_buy(course_id) {
                if (this.userstatus_info.group_buy_id){
                    this.$router.push({name: 'group_buy', params: {id: this.userstatus_info.group_buy_id}})
                }else{
                    let args = {
                        'course_id': course_id
                    }
                    groupBuyApi.start_group_buy(args).then(res => {
                        console.log(res)
                        let data = JSON.parse(res.data.result)
                        if (data.code == 'success') {
                            this.$router.push({name: 'group_buy', params: {id: data.group_buy_id}})
                        } else {
                            this.$message({
                                message: data.message,
                                type: 'warning'
                            });
                        }
                    })
                }
            },

            _change_follow: function (isFollow) {
                let id = this.$route.params.id
                this.change_follow({
                    'is_follow': isFollow,
                    'id': id
                })
            },
            join_course: function () {
                this.join({
                    id: this.$route.params.id
                })
            },
            _apply_course() {
                let course_id = this.$route.params.id;
                courseApi.get_course_applyed({'course_id': course_id}).then((res) => {
                    this.form = res.data.form
                })
                this.dialogFormVisible = true
            },
            apply_course(type) {
                let course_id = this.$route.params.id;
                if (type == 'apply') {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            courseApi.apply_course({
                                'course_id': course_id,
                                'type': 'apply',
                                'form': this.form
                            }).then((res) => {
                                let data = JSON.parse(res.data.result)
                                if (data.code == 'success') {
                                    if (this.course_info.fee_type === 'free') {
                                        this.is_applyed = true
                                        this.$message({
                                            message: data.message,
                                            type: 'success'
                                        });
                                        this.dialogFormVisible = false
                                    } else {
                                        this.to_buy(this.course_info.id)

                                        // this.dialogVisible = true
                                    }
                                }

                            })
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } else if (type == 'cancel') {
                    courseApi.apply_course({'course_id': course_id, 'type': 'cancel'}).then((res) => {
                        let data = JSON.parse(res.data.result)
                        if (data.code == 'success') {
                            this.is_applyed = false
                            this.$message({
                                message: data.message,
                                type: 'success'
                            });
                        }
                    })
                }
            },
        },
        computed: {
            ...mapState({
                course_info: state => state.course.course_information,
                scrolled: state => state.scrollBar.current_scrolled_value > 50,
                scroll_value: state => state.scrollBar.current_scrolled_value,
                course_content: state => state.course.course_labs[0],
                userstatus_info: state => state.course.course_userstatus[0],
                sign_on: state => state.loginState.sign_on,
                comments: state => state.comments.comment_information,
                qa_information: state => state.course.qa_information,
                report_info: state => state.course.report_information,
                user_info: state => state.loginState.user_info

            }),
            user_all_copper_count: function () {
                return this.user_info.gold_count * 100 + this.user_info.silver_count * 10 + this.user_info.copper_count
            },
            expense_all_copper_count: function () {
                return this.course_info.price * 100
            },
        },
        mounted: function () {
            this.get_qa({
                'course_id': this.$route.params.id,
                'page': 1
            })
            this.get_report({
                'course_id': this.$route.params.id,
            })

        }
    }
</script>

<style scoped>
     >>> .el-tabs__header {
        margin: 0 0 0 0;
    }
    >>> .el-tabs__item{
         padding: 0 10px;
     }

    .course_side_base_btn {
        width: 100%;
        /*padding-top: 12px;*/
        /*padding-bottom: 12px;*/
        box-shadow: none;
    }

    .join_in_course_button {
        color: #fff;
        background-color: #66CCFF;
        border-color: #66CCFF;
    }

    .join_in_course_button:hover {
        color: #fff;
        background-color: #069a75;
        border-color: #068e6c;
    }

    .join_member_button {
        color: #fff;
        background-color: #ff9c4a;
        border-color: #ff9c4a;
    }

    .join_member_button:hover {
        color: #fff;
        background-color: #ff8017;
        border-color: #ff8017;
    }

    .buy_course_button {
        color: #fff;
        background-color: #f66;
        border-color: #f66;
    }

    .buy_course_button:hover {
        color: #fff;
        background-color: #f33;
        border-color: #ff2626;
    }

    .apply_course_button {
        color: #fff;
        background-color: #ff9750;
        border-color: #ff9750;
    }

    .apply_course_button:hover {
        color: #fff;
        background-color: #ff9720;
        border-color: #ff9720;
    }

    .applyed_course_button {
        color: #fff;
        background-color: #66CCFF;
        border-color: #66CCFF;
    }

    .applyed_course_button:hover {
        color: #fff;
        background-color: #f33;
        border-color: #f33;
    }

    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

    .follow_course_div {
        float: left;
        /*margin-top: 50px;*/
        /*padding-top: 15px;*/
        /*border-top: 1px solid #eee;*/
        /*text-align: center;*/
        /*color: #a4a4a4;*/
    }

    .follow_span:before {
        content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAc9JREFUOBGtVE2rQVEUXVcPZeBzruSjEGIqZehPGvglRlIUSYjI15R8xEi5z9qvc3tc7977Xm/V6e69z9rr7MPeR9MfwD/C5URrPB6Dywk+7Ejz+RzdbldoHo8HiUTCMsVWsN/vI5vNightO0HLK69WK1wuF+RyOVm0GbOCpSArymQy8Hq9stLpNBizgnHl+/2O8/ks63g8Yr/f43A4oFarGfn5fB6j0QjNZhORSATBYBB+v1+Wy/VVm8a2abVamEwmoKjb7UYgEBBSNBpFKpUyBGlMp1Nst1ucTic5/Ha7gWKsvlwuAxRsNBp6u93Wr9cr3V+BOcylBiF1VioV6bPdbvdUjROHOexRaghUOYvFQq/X6/p6vVYh2y+5zGGuglxZOb8RfSdGnSdBBh7ly6mPP4juW3CPlZH7ClMfcrx8Ph80TfvxJ+QeOeS+wiTI3guFQq88k08Oua8wGlttkBQOh5UL9tlgMBC/UChIn9Ihx7FgLBaTJudUcNRUxWyPYrEojwVjy+XSOFgZpgr5AHDs+GRxaqrVKjgxxGazQafTwXA4RDwel4dDCamvjJ5y+O31epLIJyuZTH7fMuzZbCbNzINKpZIRp2ESfNr9g/MJ9WrieGiQzqYAAAAASUVORK5CYII=);
        vertical-align: middle;
    }

    .followed_span:before {
        content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAapJREFUOBHVlL9LQlEUx895Sjj0D+iaFpUNEc1BEdTSEA0NranPqbGG4k1RBGGD+IP2aIhoaW+NBqFoUBqiINGgaEyfp+995kN99jSX6IKec8/53s+5P44S/cWQaDQjur7YS23uJgJoikzzhpjvye+fYMOoua3R3JJWzjR3LCsyRsXiSje9K1BisUkAlmyIyLaIuJ7KFUgA2DDliIRJ15dbYm0Tu5rE44PIBalWG4YNwY7AruFja+Bjxk8AX8ArwM/DL1Ag8Ii7rVpp9SWRyDXMtPL7HBXANzmTOawfWdP2Aar0CVPLHrDTE+VYQE6nz8jjUS/4qYK/Gsx3pGkznM2+qHUt94MGXkClc8R9PUJz0M0D9trQtwBVENA5QC/hDjREP9gcTjXLqdRbc97ZNn7/VbPAxb9thymtE1gqhRDvtjvVPuFOxZzAarWj0LFYZFQMw7HeEXBUZi4itgHgMazVvN9wH5XLwfZCTiBRfYfM6rK38EBDaNgjvOQ6eb3jgJ4iLhaow2m87RUAeEZf7ZLPd8CJxHtznpPJPOar+Jnu4S/NgO6jOf8//C8DrX88kmxjGQAAAABJRU5ErkJggg==);
        vertical-align: middle;
    }

    .footer-box {
        width: 100%;
        height: 50px;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 1;
        display: flex;
        padding: 0 10px;
        box-shadow: 0 0 1px 0;
        align-items: center;
    }

    .comments-text {
        padding: 0 10px;
        /*font-size:28px;*/
        color: #666666;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 30px;
    }

    .course_numbers_div {
        display: flex;
    }

    .course_numbers_p {
        margin-right: 10px;
        font-size: 14px;
        color: #a4a4a4;
    }

    .course_numbers_line:before {
        content: "";
        display: inline-block;
        height: 30px;
        width: 1px;
        background: #eee;
        /*margin: 0 8px -9px 4px;*/
    }

    .bootcamp_price {
        color: #f66;
        font-weight: 700;
        font-size: 16px;
    }

</style>